export enum PurchaseType {
    PURCHASE_REQUEST = 'PURCHASE_REQUEST',
    PURCHASE_ORDER = 'PURCHASE_ORDER',
}
